export default __webpack_public_path__ + "static/media/pavlova.e231515f.jpg";